import React, { useContext, useEffect, useState } from "react";
import { Alert, Dialog, Table } from "../../layout";
import { Button } from "../../controls";
import AddEditInv from "./AddEditInv";
import { Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../App";
import { API, actions, endpoints } from "../../api/api";
import moment from "moment";
import { useTranslation } from "react-i18next";

const Invoices = () => {
  const [showForm, setShowForm] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { branch, setLoader } = useContext(AppContext);
  const [invs, setInvs] = useState([]);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    setLoader(true);
    if (branch.id) {
      API(endpoints.Invoice + actions.GetAllByBranch).getById(
        branch.id,
        (res) => {
          res.status === 200 && setInvs([...res.result]);
          setLoader(false);
        }
      );
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch]);

  const handleAddEdit = () => {
    navigate("/invoice_form");
  };

  const HeaderComp = () => (
    <div>
      <Button onClick={() => handleAddEdit()}>Add Invoice</Button>
    </div>
  );

  const InvStatus = ({ status }) => {
    switch (status) {
      case 1:
        return (
          <span className="fs-12 fw-5 bg-successXS success-color pb-5 pt-5 pl-10 pr-10 w-fit br-8 tx-upp">
            {t("Active")}
          </span>
        );
      case 2:
        return (
          <span className="fs-12 fw-5 bg-primarySM primary-color pb-5 pt-5 pl-10 pr-10 w-fit br-8 tx-upp">
            {t("NotStartedYet")}
          </span>
        );
      case 3:
        return (
          <span className="fs-12 fw-5 bg-grayXS gray-color pb-5 pt-5 pl-10 pr-10 w-fit br-8 tx-upp">
            {t("NotStartedYet")}
          </span>
        );
      default:
        break;
    }
  };

  return (
    <>
      <Table
        ActionComp={() => <></>}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "status", label: t("Status") },
          { id: "name", label: t("Member") },
          { id: "id", label: t("IDFreeFreeze") },
          { id: "amt", label: t("Amount") },
          { id: "subs", label: t("Subscription") },
          { id: "duration", label: t("Duration") },
          { id: "paymentDate", label: t("PaymentDate") },
          { id: "planDate", label: t("PlanDate") },
        ]}
        tblData={invs.map((inv) => {
          return {
            ...inv,
            status: (
              <div className="d-flex g-10">
                {/* Payment Status */}
                {inv.status === 2 ? (
                  <span className="fs-12 fw-5 bg-successXS success-color pb-5 pt-5 pl-10 pr-10 w-fit br-8 tx-upp">
                    {t("Paid")}
                  </span>
                ) : new Date(moment(inv.dueDate, "MM-DD-YYYY").add(1, "days")) <
                  new Date() ? (
                  <span className="fs-12 fw-5 bg-errorSM error-color pb-5 pt-5 pl-10 pr-10 w-fit br-8 tx-upp">
                    {t("Overdue")}
                  </span>
                ) : (
                  <span className="fs-12 fw-5 bg-primarySM primary-color pb-5 pt-5 pl-10 pr-10 w-fit br-8 tx-upp">
                    {t("Due")}
                  </span>
                )}

                {/* Invoice Status */}
                <InvStatus status={inv.invStatus} />
              </div>
            ),

            id: (
              <div className="d-grid fs-14 w-fit">
                <span>
                  <span className="fw-6 fs-12">{t("InvoiceId")}: &nbsp;</span>{" "}
                  {inv.id}
                </span>
                <span>
                  <span className="fw-6 fs-12">{t("FreeFreeze")}:</span>&nbsp;
                  {inv.freeFreezeCount}
                </span>
              </div>
            ),

            name: (
              <div className="d-grid fs-14 w-fit">
                <span>
                  <span className="fs-12 fw-6">{t("Member")}: &nbsp;</span>{" "}
                  {inv.member &&
                    inv.member.firstName + " " + inv.member.lastName}{" "}
                  (ID: {inv.member.memberId})
                </span>
                <span>
                  <span className="fw-6 fs-12">{t("Title")}: &nbsp;</span>{" "}
                  {inv.title}
                </span>
              </div>
            ),

            subs: (
              <div className="d-grid fs-14 w-fit">
                <span>
                  <span className="fw-6 fs-12">{t("Type")}:&nbsp;</span>
                  {inv.subsType && inv.subsType.name}
                </span>
                <span>
                  <span className="fw-6 fs-12">{t("Plan")}:&nbsp;</span>
                  {inv.subsPlan && inv.subsPlan.name}
                </span>
              </div>
            ),
            amt: (
              <div className="fs-12 d-flex a-center g-5">
                <div className="d-grid g-2 w-fit">
                  <span>
                    {t("Paid")}:&nbsp;&nbsp;{inv.paidAmt || 0}&nbsp;
                    {branch && branch.currency}
                  </span>
                  <Divider />
                  <span>
                    {t("Total")}:&nbsp;&nbsp;{inv.amount}&nbsp;
                    {branch && branch.currency}
                  </span>
                </div>
                <span>
                  {t("Due")}:&nbsp;&nbsp;
                  {parseFloat(inv.amount) - parseFloat(inv.paidAmt || 0)}
                  &nbsp;
                  {branch && branch.currency}
                </span>
              </div>
            ),
            duration: `${inv.duration} Days`,
            paymentDate: (
              <div className="d-grid fs-14 w-fit">
                <span>
                  <span className="fw-6 fs-12">{t("DueDate")}:</span>{" "}
                  {inv.dueDate}
                </span>
                <span>
                  <span className="fw-6 fs-12">{t("PaidDate")}:</span>{" "}
                  {inv.paidDate}
                </span>
              </div>
            ),
            planDate: (
              <div className="d-grid fs-14 w-fit">
                <span>
                  <span className="fw-6 fs-12">{t("Start")}:</span>{" "}
                  {inv.startDate}
                </span>
                <span>
                  <span className="fw-6 fs-12">{t("End")}:</span> {inv.endDate}
                </span>
              </div>
            ),
          };
        })}
      />

      {/* Add Follow Up */}
      <Dialog show={showForm} onClose={false} maxWidth="md">
        <AddEditInv {...{ setShowForm, setAlert }} />
      </Dialog>

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default Invoices;
